import { IAppConfig } from "interfaces/app-config.interface";

export enum AppActionTypes {
  FETCH_APP_CONFIG_REQUEST = "FETCH_APP_CONFIG_REQUEST",
  FETCH_APP_CONFIG_SUCCESS = "FETCH_APP_CONFIG_SUCCESS",
  FETCH_APP_CONFIG_FAILURE = "FETCH_APP_CONFIG_FAILURE",
  UPDATE_APP_CONFIG_REQUEST = "STORE_APP_CONFIG_REQUEST",
  UPDATE_APP_CONFIG_SUCCESS = "STORE_APP_CONFIG_SUCCESS",
  UPDATE_APP_CONFIG_FAILURE = "STORE_APP_CONFIG_FAILURE",
}

// Action interfaces
export interface FetchAppConfigRequestAction {
  type: AppActionTypes.FETCH_APP_CONFIG_REQUEST;
}

export interface FetchAppConfigSuccessAction {
  type: AppActionTypes.FETCH_APP_CONFIG_SUCCESS;
  payload: IAppConfig;
}

export interface FetchAppConfigFailureAction {
  type: AppActionTypes.FETCH_APP_CONFIG_FAILURE;
  payload: string;
}

export interface UpdateAppConfigRequestAction {
  type: AppActionTypes.UPDATE_APP_CONFIG_REQUEST;
  payload: IAppConfig;
}

export interface UpdateAppConfigSuccessAction {
  type: AppActionTypes.UPDATE_APP_CONFIG_SUCCESS;
  payload: IAppConfig;
}

export interface UpdateAppConfigFailureAction {
  type: AppActionTypes.UPDATE_APP_CONFIG_FAILURE;
  payload: string;
}

// Action creators
export const fetchAppConfigRequest = (): FetchAppConfigRequestAction => ({
  type: AppActionTypes.FETCH_APP_CONFIG_REQUEST,
});

export const fetchAppConfigSuccess = (
  data: IAppConfig
): FetchAppConfigSuccessAction => ({
  type: AppActionTypes.FETCH_APP_CONFIG_SUCCESS,
  payload: data,
});

export const fetchAppConfigFailure = (
  error: string
): FetchAppConfigFailureAction => ({
  type: AppActionTypes.FETCH_APP_CONFIG_FAILURE,
  payload: error,
});

export const updateAppConfigRequest = (
  data: IAppConfig
): UpdateAppConfigRequestAction => ({
  type: AppActionTypes.UPDATE_APP_CONFIG_REQUEST,
  payload: data,
});

export const updateAppConfigSuccess = (
  data: IAppConfig
): UpdateAppConfigSuccessAction => ({
  type: AppActionTypes.UPDATE_APP_CONFIG_SUCCESS,
  payload: data,
});

export const updateAppConfigFailure = (
  error: string
): UpdateAppConfigFailureAction => ({
  type: AppActionTypes.UPDATE_APP_CONFIG_FAILURE,
  payload: error,
});

export type AppActions =
  | FetchAppConfigRequestAction
  | FetchAppConfigSuccessAction
  | FetchAppConfigFailureAction
  | UpdateAppConfigRequestAction
  | UpdateAppConfigSuccessAction
  | UpdateAppConfigFailureAction;
